import React, {Component} from 'react'
import '../styles/index.scss'
import LabelPageV2 from './LabelPageV2'

class LabelsPageContainer extends Component {
    render() {
        return (
            <div className='LabelsPageContainer'>
                <LabelPageV2/>
            </div>
        )
    }
}

export default LabelsPageContainer
